import { render, staticRenderFns } from "./LandingControl.vue?vue&type=template&id=5c19033c&scoped=true&"
import script from "./LandingControl.vue?vue&type=script&lang=js&"
export * from "./LandingControl.vue?vue&type=script&lang=js&"
import style0 from "./LandingControl.vue?vue&type=style&index=0&id=5c19033c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c19033c",
  null
  
)

export default component.exports